import { render } from "./PromoCode.vue?vue&type=template&id=5f22da13&scoped=true"
import script from "./PromoCode.vue?vue&type=script&lang=js"
export * from "./PromoCode.vue?vue&type=script&lang=js"

import "./PromoCode.vue?vue&type=style&index=0&id=5f22da13&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f22da13"

export default script